import { render, staticRenderFns } from "./PatientPortalView.vue?vue&type=template&id=2071a55e&"
import script from "./PatientPortalView.vue?vue&type=script&lang=ts&"
export * from "./PatientPortalView.vue?vue&type=script&lang=ts&"
import style0 from "./PatientPortalView.vue?vue&type=style&index=0&id=2071a55e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports